'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.init = init;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactDom = require('react-dom');

var _reactDom2 = _interopRequireDefault(_reactDom);

var _themeCart = require('@shopify/theme-cart');

var shopifyCart = _interopRequireWildcard(_themeCart);

var _reactHotLoader = require('react-hot-loader');

var _pushCartActions = require('../store/actions/push-cart-actions');

var pushCartActions = _interopRequireWildcard(_pushCartActions);

var _PushCartContainer = require('../react/containers/PushCartContainer');

var _functional = require('../utils/functional');

var _baoCart = require('./bao-cart');

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
      }
    }newObj.default = obj;return newObj;
  }
}

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function init(_ref) {
  var el = _ref.el;

  var action = el.dataset.action;
  var submitTo = el.dataset.submitTo;
  var pushCartUpsellHandles = el.dataset.pushCartUpsellHandles.split(',').filter(function (h) {
    return h;
  });
  var recommendedProducts = [];
  console.log(pushCartUpsellHandles, 'handles');

  shopifyCart.getState().then(function (data) {
    // const products = [];

    // for (const handle of pushCartUpsellHandles) {
    //     const product = await fetchProductData(handle);
    //     console.log(product);
    //     products.push(product);
    // }

    // console.log(products);
    // window.store.dispatch(pushCartActions.updateLineItems(data));


    //     console.log(pushCartUpsellHandles, 'handles in response');
    //   Promise.all(
    //     pushCartUpsellHandles.map(async handle => {
    //       const productData = await fetchProductData(handle)
    //       console.log(productData);
    //       return productData;
    //     })
    //   ).then(resp => {
    //     console.log(recommendedProducts, resp, 'recommendedProductsResponse');
    //     recommendedProducts.push(resp)
    //     window.store.dispatch(pushCartActions.updateLineItems(data))
    //   })
  }).catch(function (err) {
    return console.error('Push cart error: ' + err);
  });

  window.BAOCart = new _baoCart.BAOCart();

  var render = function render(Component) {
    console.log(recommendedProducts, 'recommendedProducts');
    _reactDom2.default.render(_react2.default.createElement(_reactHotLoader.AppContainer, null, _react2.default.createElement(Component, { action: action, submitTo: submitTo, recommendedProducts: recommendedProducts })), el);
  };

  render(_PushCartContainer.PushCartContainer);

  if (module.hot) {
    module.hot.accept('../react/containers/PushCartContainer.js', function () {
      var PushCartContainer = require('../react/containers/PushCartContainer').PushCartContainer;

      render(PushCartContainer);
    });
  }
}